/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.26/esri/copyright.txt for details.
*/
var _;!function(_){_.GLTF_BINARY="3D_glb",_.GLTF_JSON="3D_gltf"}(_||(_={}));export{_ as AssetType};
